export default "__VITE_ASSET__XxeD4tuT__"